import useWidth from '@components/Hooks/useWidth';
import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import OrdersIllustration from '@components/v2/ui/EmptyState/svg/OrdersIllustration';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { useIsRachelAvailable } from '../../../../rachel/hooks/useIsRachelAvailable';
import { useRachelPageNavigation } from '../../../../rachel/hooks/useRachelPageNavigation';
import { useRachelStore } from '../../../../rachel/store/rachel.store';
import { selectOpenRachel } from '../../../../rachel/store/rachel.store.selectors';

const CONTENT_INDENT = 10;

interface OrderProductsEmptyStateProps {
  onClickAddItem?: () => void;
  isFiltered?: boolean;
}

const OrderProductsEmptyState = ({ onClickAddItem, isFiltered }: OrderProductsEmptyStateProps) => {
  const isRachelAvailable = useIsRachelAvailable();
  const openRachel = useRachelStore(selectOpenRachel);
  const { openPage } = useRachelPageNavigation();
  const { mobileWidth } = useWidth();

  const handleClickMoreDetails = () => {
    if (mobileWidth) {
      openPage();
      return;
    }

    openRachel();
  };

  const secondaryAction = isRachelAvailable
    ? { label: LangEnum.GLOBAL_MORE_DETAILS, onClick: handleClickMoreDetails }
    : undefined;

  const action =
    onClickAddItem && !isFiltered
      ? {
          primary: {
            label: LangEnum.ORDER_PRODUCTS_EMPTY_ADD_ITEM_BUTTON,
            onClick: onClickAddItem,
          },
          secondary: secondaryAction,
        }
      : undefined;

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: { xs: 'center', md: 'flex-start' },
        ml: { xs: 0, md: CONTENT_INDENT },
        px: { xs: 3, md: 0 },
      }}
    >
      <EmptyState
        title={{
          text: isFiltered ? LangEnum.GLOBAL_LIST_NO_RESULTS_TITLE : LangEnum.GLOBAL_PRODUCTS,
        }}
        description={{
          text: isFiltered
            ? LangEnum.GLOBAL_LIST_NO_RESULTS_DESCRIPTION
            : LangEnum.ORDER_PRODUCTS_EMPTY_DESCRIPTION,
        }}
        illustration={isFiltered ? undefined : <OrdersIllustration />}
        action={action}
      />
    </Stack>
  );
};

export default OrderProductsEmptyState;
